import React, {useState} from "react";
import CustomContainer from "../../components/CustomContainer";
import Loader from "../../components/Loader";
import {LinkIconButton} from "../../components/button/LinkIconButton";
import AlarmComponent from "../../components/alarm/AlarmComponent";
import { useTranslation } from 'react-i18next';
import { useModels } from "../../helpers/models";

const DashboardPage = (props) => {
    const { t } = useTranslation();

    const [loader, setLoader] = useState(false);
    const [reload, setReload] = useState(false);
    const models = useModels();


    return (
        <>
            <Loader loader={loader}/>
            <CustomContainer
                title={t("menu.main_panel")}
                
                parent={
                    <LinkIconButton
                        model={models.main}
                    />
                }
            >

                <AlarmComponent
                    api={"alarm"}
                    setLoader={setLoader}
                    title={"Alarmy"}
                />

            </CustomContainer>
        </>
    );
};

export default DashboardPage;
